var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLaptop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffffff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2, 4)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2,0 H18 C19,0 20,1 20,2 V11 C20,12 19,13 18,13 H2 C1,13 0,12 0,11 V2 C0,1 1,0 2,0 Z M1,2 V11 C1,11.5 1.5,12 2,12 H18 C18.5,12 19,11.5 19,11 V2 C19,1.5 18.5,1 18,1 H2 C1.5,1 1,1.5 1,2 Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    y: 14,
    width: 20,
    height: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLaptop);
export default __webpack_public_path__ + "static/media/ic_laptop.ce212d0147c1a29602f40f28c148e619.svg";
export { ForwardRef as ReactComponent };